export const playerUxCopy = {
  de: {
    serviceApproveShort: "Freigeben", serviceDeclineShort: "Ablehnen",
    notificationClosed: "Abgeschlossen",
    notificationServiceResponse: "Rückmeldung zum Service",
    notificationFeedback: "Trainingsfeedback", notificationMatchFeedback: "Spielfeedback",
    notificationFeedbackRecorded: "Feedback gespeichert",
    notificationConversation: "Gespräch mit Care", notificationReply: "Deine Antwort",
    notificationUnavailable: "Vorgang nicht verfügbar", notificationMealReview: "Ernährungsplan",
    notificationPlanUpdate: "Planänderung", notificationCareReply: "Antwort von Care",
    careResponseRequired: "Antwort des Spielers erforderlich",
    deliveryPlayer_address_needed: "Bitte Lieferadresse ergänzen",
    deliveryPlayer_review_needed: "Deine Planfreigabe nötig",
    deliveryReviewAction: "Ernährungsplan prüfen",
    deliveryPlayer_organizing: "Wir bereiten deine Lieferung vor",
    deliveryPlayer_ordered: "Bestellt – der Anbieter bereitet die Lieferung vor",
    deliveryPlayer_shipping: "Lieferung angekündigt", deliveryPlayer_delivered: "Geliefert",
    deliveryPlayer_cancelled: "Storniert", deliveryPlayer_failed: "Lieferung nicht abgeschlossen",
    deliveryAddressAction: "Lieferadresse prüfen",
    servicePlayer_cost_approval: "Deine Kostenfreigabe nötig",
    servicePlayer_confirmation: "Deine Bestätigung nötig",
    servicePlayer_change_confirmation: "Änderung bitte bestätigen",
    servicePlayer_access_details: "Zugang bitte ergänzen",
    servicePlayer_organizing: "Wir kümmern uns",
    servicePlayer_provider_confirmation: "Terminbestätigung ausstehend",
    servicePlayer_confirmed: "Termin bestätigt",
    servicePlayer_completed: "Erledigt",
    servicePlayer_cancelled: "Storniert",
    servicePlayer_failed: "Nicht durchgeführt",
    servicePlayer_problem_review: "Wir klären dein Anliegen",
    serviceNoAction: "Du musst gerade nichts tun.",
    serviceProviderNext: "Wir holen die Terminbestätigung beim Anbieter ein.",
    serviceActionNext: "Bitte öffne den Service für deine Rückmeldung.",
    serviceOwnApprovalDone: "Deine Kostenfreigabe liegt vor.",
    serviceCosts: "Kosten", serviceOptionalDetails: "Wünsche und Details ergänzen (optional)",
    serviceCategoryOptional: "Art des Services (optional)", serviceCategoryCare: "Care ordnet mein Anliegen zu",
    servicesIntro: "Wir organisieren Leistungen und Termine für dich.",
    requestsIntro: "Deine Fragen und Nachrichten an Care.",
    requestsEmptyOpen: "Keine offenen Gespräche. Du kannst Care jederzeit eine Nachricht senden.",
    requestPlayer_care_working: "Wir kümmern uns",
    requestPlayer_care_reply_pending: "Antwort von Care ausstehend",
    requestPlayer_new_reply: "Antwort von Care",
    requestPlayer_response_requested: "Deine Antwort nötig",
    requestPlayer_completed: "Erledigt",
    requestGenericTopic: "Gespräch mit Care",
    notificationState_action_required: "Deine Aktion nötig",
    notificationState_information: "Information",
    notificationState_completed: "Erledigt",
    notificationKindsHint: "Wichtige Hinweise und offene Aufgaben auf einen Blick.",
    planUpdateGroup: "Planänderungen", planUpdateCount: "Mitteilungen für diesen Tag",
    serviceProposalOpen: "Änderung zur Prüfung", serviceProposalClosed: "Stand der Änderung",
  },
  en: {
    serviceApproveShort: "Approve", serviceDeclineShort: "Decline",
    notificationClosed: "Closed",
    notificationServiceResponse: "Service response",
    notificationFeedback: "Training feedback", notificationMatchFeedback: "Match feedback",
    notificationFeedbackRecorded: "Feedback saved",
    notificationConversation: "Conversation with Care", notificationReply: "Your reply",
    notificationUnavailable: "Item unavailable", notificationMealReview: "Meal plan",
    notificationPlanUpdate: "Plan update", notificationCareReply: "Reply from Care",
    careResponseRequired: "Player reply required",
    deliveryPlayer_address_needed: "Please add your delivery address",
    deliveryPlayer_review_needed: "Your plan approval is needed",
    deliveryReviewAction: "Review meal plan",
    deliveryPlayer_organizing: "We’re preparing your delivery",
    deliveryPlayer_ordered: "Ordered – the provider is preparing your delivery",
    deliveryPlayer_shipping: "Delivery announced", deliveryPlayer_delivered: "Delivered",
    deliveryPlayer_cancelled: "Cancelled", deliveryPlayer_failed: "Delivery not completed",
    deliveryAddressAction: "Check delivery address",
    servicePlayer_cost_approval: "Your cost approval is needed",
    servicePlayer_confirmation: "Your confirmation is needed",
    servicePlayer_change_confirmation: "Please confirm the change",
    servicePlayer_access_details: "Please add access details",
    servicePlayer_organizing: "We’re taking care of it",
    servicePlayer_provider_confirmation: "Awaiting appointment confirmation",
    servicePlayer_confirmed: "Appointment confirmed",
    servicePlayer_completed: "Completed", servicePlayer_cancelled: "Cancelled",
    servicePlayer_failed: "Not carried out", servicePlayer_problem_review: "We’re following up for you",
    serviceNoAction: "You don’t need to do anything right now.",
    serviceProviderNext: "We’re arranging confirmation with the provider.",
    serviceActionNext: "Open the service to respond.", serviceOwnApprovalDone: "Your cost approval is recorded.",
    serviceCosts: "Cost", serviceOptionalDetails: "Add preferences and details (optional)",
    serviceCategoryOptional: "Service type (optional)", serviceCategoryCare: "Let Care assign the category",
    servicesIntro: "We organise services and appointments for you.",
    requestsIntro: "Your questions and messages to Care.",
    requestsEmptyOpen: "No open conversations. You can message Care anytime.",
    requestPlayer_care_working: "We’re taking care of it", requestPlayer_care_reply_pending: "Awaiting Care’s reply",
    requestPlayer_new_reply: "Reply from Care",
    requestPlayer_response_requested: "Your reply is needed", requestPlayer_completed: "Completed",
    requestGenericTopic: "Conversation with Care",
    notificationState_action_required: "Your action is needed", notificationState_information: "Information",
    notificationState_completed: "Completed",
    notificationKindsHint: "Important updates and outstanding tasks at a glance.",
    planUpdateGroup: "Plan updates", planUpdateCount: "notifications for this day",
    serviceProposalOpen: "Change for review", serviceProposalClosed: "Change status",
  },
};
